import { ROOT_ID } from "../utils";
export const getItemPath = (itemId, flattenedTreeModel) => {
    const itemUIModel = flattenedTreeModel.get(itemId);
    if (!itemUIModel) {
        return null;
    }
    const itemPath = [itemUIModel.item];
    let currentItemUIModel = itemUIModel;
    while (currentItemUIModel.parentItem.id !== ROOT_ID) {
        itemPath.push(currentItemUIModel.parentItem);
        currentItemUIModel = flattenedTreeModel.get(currentItemUIModel.parentItem.id);
    }
    return itemPath.reverse();
};
